import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { estaAberto, formatarHorarioFuncionamento } from '../../../utils/storeHours';

const StoreList = ({ stores }) => {


  const handleContactClick = (e, type, contact) => {
    e?.preventDefault();
    e?.stopPropagation();
    
    if (type === 'phone') {
      window.open(`tel:${contact}`, '_self');
    } else if (type === 'whatsapp') {
      window.open(`https://wa.me/55${contact?.replace(/\D/g, '')}`, '_blank');
    }
  };

  return (
    <div className="space-y-4">
      {stores?.map((store) => (
        <div
          key={store?.id}
          className="bg-card rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300 overflow-hidden"
        >
          <div className="flex flex-col sm:flex-row">
            {/* Image with Background */}
            <div className="relative w-full sm:w-48 h-48 sm:h-32 flex-shrink-0 overflow-hidden bg-muted/30">
              <Image
                src={store?.imagem || "/assets/images/no_image.png"}
                alt={`Foto ${store?.nome}`}
                className="w-full h-full object-cover"
              />
              
              {/* Status Badge */}
              <div className="absolute top-3 left-3 z-20">
                {(() => {
                  const isAberto = estaAberto(store?.horarioFuncionamento);
                  return (
                    <span className={`
                      inline-flex items-center px-2 py-1 rounded-full text-xs font-medium backdrop-blur-sm
                      ${isAberto 
                        ? 'bg-success/90 text-success-foreground' 
                        : 'bg-destructive/90 text-destructive-foreground'
                      }
                    `}>
                      <div className={`w-2 h-2 rounded-full mr-1 ${isAberto ? 'bg-green-400' : 'bg-red-400'}`} />
                      {isAberto ? 'Aberto' : 'Fechado'}
                    </span>
                  );
                })()}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 p-4">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-1">
                    <div className="flex items-center gap-2 ml-4">
                      <span className="text-[11px] text-muted-foreground">
                        {store?.andar}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Informações Principais */}
              <div className="flex flex-wrap items-center gap-3 mb-2 text-[11px]">
                {/* Nicho */}
                <div className="flex items-center gap-1">
                  <Icon name="Tag" size={11} className="text-primary" />
                  <span className="text-primary font-semibold">{store?.tipo}</span>
                </div>
                
                {/* Horário */}
                <div className="flex items-start gap-1 text-muted-foreground">
                  <Icon name="Clock" size={10} className="mt-0.5 flex-shrink-0" />
                  <span className="text-xs sm:text-sm leading-relaxed break-words">{formatarHorarioFuncionamento(store?.horarioFuncionamento)}</span>
                </div>

                {/* Redes Sociais */}
                {(store?.redesSociais?.instagram || store?.redesSociais?.facebook) && (
                  <div className="flex items-center gap-1.5">
                    <Icon name="Share2" size={10} className="text-muted-foreground" />
                    {store?.redesSociais?.instagram && (
                      <a
                        href={store.redesSociais.instagram.startsWith('http') ? store.redesSociais.instagram : `https://instagram.com/${store.redesSociais.instagram.replace('@', '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline text-[10px]"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Instagram
                      </a>
                    )}
                    {store?.redesSociais?.facebook && (
                      <a
                        href={store.redesSociais.facebook.startsWith('http') ? store.redesSociais.facebook : `https://facebook.com/${store.redesSociais.facebook}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline text-[10px]"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Facebook
                      </a>
                    )}
                  </div>
                )}
              </div>

              <h3 className="font-heading font-semibold text-foreground text-lg mb-2">
                {store?.nome}
              </h3>
              {store?.id === 'mercadoLivre' && (
                <div className="inline-flex items-center gap-1 rounded-full bg-foreground/10 px-2 py-1 text-[11px] font-medium text-foreground mb-2">
                  <Icon name="ShoppingBag" size={12} className="text-primary" />
                  Agência Mercado Livre
                </div>
              )}

              {/* Description */}
              <p className="text-sm text-muted-foreground mb-2 line-clamp-2 leading-relaxed">
                {store?.descricao}
              </p>

              {/* Actions */}
              <div className="flex items-center gap-2">
                <Link 
                  to={`/store-detail?id=${store?.id}`}
                  className="flex-1"
                >
                  <Button variant="default" size="sm" className="w-full">
                    Ver Detalhes
                  </Button>
                </Link>
                
                {store?.whatsapp && (
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={(e) => handleContactClick(e, 'whatsapp', store?.whatsapp)}
                    title="WhatsApp"
                  >
                    <Icon name="MessageCircle" size={14} />
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StoreList;